import React, { useContext, useState } from 'react';

import { NCRContext } from "views";
import { UserContext } from 'components/routing'

import { ConditionModal } from 'components/layout';
import { RadioButton } from 'components/form/prototypes';

const Condition = ({ condition, setCondition }) => {

  const { state } = useContext(NCRContext);
  const { user } = useContext(UserContext);

  const [showModal, setShowModal] = useState(false);

  const callback = required => !required ? setShowModal(true) : setCondition(true) ;

  const isDisabled =
    ['QA', 'GM'].includes(user.role)
      ? state.ncr.status.id > 8
      : state.ncr.status.id > 1;

  return (
    <>
    <ConditionModal showModal={showModal} setShowModal={setShowModal} setCondition={setCondition} />
    <RadioButton
      name='ncr.return.condition'
      label='Is the order in the same condition/packaging as it was sent?'
      value={condition}
      callback={callback}
      disabled={isDisabled}
    />
    </>
  )
}

export { Condition };
